import { FEATURES } from '/src/features/_global/constants';

export const AD_PLATFORM_ANALYTICS_PERMISSIONS = {
  [FEATURES.AD_PLATFORM_ANALYTICS]: ({ capabilities }) => ({
    navigate: capabilities?.adPlatformAnalytics?.permissions?.nav,
    view: capabilities?.adPlatformAnalytics?.permissions?.view,
  }),
};
